/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.uploadModule')

/**
 * BulbUploadService manages uploads.
 * Provides:
 * 1. A notion of "the current upload";
 * 2. The mapping between the asset Id and the Plupload file object for recent uploads;
 *     This mapping is unique by file.id, NOT by file.name, since the user may upload the same file,
 *     or a different file with the same name, multiple times;
 * 3. The getNewAssetId method, for getting the next asset Id from the server;
 * 4. The cancelUpload method, for aborting a multi-part upload on the server.
 */
.service('BulbUploadService', ['$q', 'BulbErrorService', 'Restangular', BulbUploadService]);

function BulbUploadService($q, BulbErrorService, Restangular) {
  var that = this;

  this.currentUpload = null;
  this.uploads = {};

  // Private function to get a Plupload file object, referenced by assetId or file.id.
  function getFile(arg) {
    if (typeof arg === 'string') {
      // assetId
      return that.uploads[arg];
    } else if (arg.id) {
      // file.id
      return that.uploads[arg.id];
    }
  }

  /**
   * Mark the current upload started.
   * @param assetId The asset Id currently being uploaded.
   * @param file The plupload file object currently being uploaded.
   */
  this.startUpload = function(assetId, file) {
    // Add the asset Id to the file object.
    file.assetId = assetId;
    this.currentUpload = file;
    this.uploads[file.id] = file;
    this.uploads[assetId] = file;
  };

  /**
   * Return true if the arg references the current upload.
   * @param arg either a string (interpreted as an assetId) or a Plupload file object.
   * @returns true if the arg references the current upload, else false.
   */
  this.isCurrentUpload = function(arg) {
    var file = getFile(arg);
    if (!file || !this.currentUpload) {
      return false;
    }
    return file.id === this.currentUpload.id;
  };

  /**
   * Mark the specified upload ended: remove it from this.uploads.
   * @param arg either a string (interpreted as an assetId) or a Plupload file object.
   */
  this.endUpload = function(arg) {
    var file = getFile(arg);
    // May already have been deleted by cancelUpload.
    if (file) {
      if (this.currentUpload.id === file.id) {
        this.currentUpload = null;
      }
      delete this.uploads[file.id];
      delete this.uploads[file.assetId];
    }
  };

  /**
   * Get a new assetId for the next upload.
   * @returns a promise that resolves to the new assetId.
   */
  this.getNewAssetId = function() {
    var deferred = $q.defer();
    Restangular.all('assets').customGET('newId').then(function (objectId) {
      deferred.resolve(objectId);
    }, function(error) {
      var errorMessage = BulbErrorService.error('Cannot get new asset Id', error);
      deferred.reject(errorMessage);
    });
    return deferred.promise;
  };

  /**
   * Cancel the specified upload: abort the multi-part upload and delete the unsaved asset on the server.
   * @param arg either a string (interpreted as an assetId) or a Plupload file object.
   * @returns a promise that resolves to true on success, resolves to false if not found, and is rejected on error.
   */
  this.cancelUpload = function(arg) {
    var deferred = $q.defer();
    var file = getFile(arg);
    if (file) {
      Restangular.one('assets', file.assetId).customDELETE('').then(function () {
        that.endUpload(file);
        deferred.resolve(true);
      }, function (error) {
        var errorMessage = BulbErrorService.error('Cannot cancel upload of ' + file.name, error);
        that.endUpload(file);
        deferred.reject(errorMessage);
      });
    } else {
      deferred.resolve(false);
    }
    return deferred.promise;
  };
}

